import { useQuery } from "@tanstack/react-query";
import { getVacanciesLogs } from "../../api/vacancies";


export default function useGetVacanciesLogs() {
  const {data} = useQuery(
    {
      queryKey: ['vacancyLogs'],
      queryFn:  async () => {
        return await getVacanciesLogs();
     }
    }
  )

  const logs = data?.map(log => {
    const offset = new Date().getTimezoneOffset() * 60 * 1e3
    const ts = new Date(parseInt(log.timestamp) - offset).toISOString().split('.')[0]
    const [date, time] = ts.split('T')
    const [_, month, day] = date.split('-')
    const [hour, minute, _second] = time.split(':')
    return {
      ...log,
      timestamp: `${day}.${month} ${parseInt(hour)}:${minute}`
    }
  })

  return {logs}
}